import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  description: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  card: {
    marginBottom: theme.spacing(2),
    boxShadow: theme.shadows[2],
    borderRadius: 8,
  },
  cardContent: {
    padding: theme.spacing(2),
  },
  cardTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  icon: {
    marginRight: theme.spacing(1),
    fontSize: 24,
  },
  timeContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  timeField: {
    flex: 1,
  },
  saveButton: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5, 4),
  },
  infoBox: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.info.light,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'flex-start',
  },
  infoIcon: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
}))

export { useStyles }
